/**
 * Directions-step status — the single shared palette for the ORDER "D" level.
 *
 * A Directions step (designs.basic_stages[i]) carries a tri-state status chip:
 * Pending / Active / Completed. Its sub-steps (basic_stages[i].substeps[j])
 * carry their own status too (same palette), as do the Basic-section items.
 *
 * Lives here (not in TkneTool) because ASTRA's TKNE orbit layer colours its
 * orbs from exactly these values; two copies would silently drift apart.
 */

/** Directions-step status: Pending / Active / Completed. */
export type StepStatus = 'P' | 'S' | 'C';

export const STEP_STATUS_META: Record<
  StepStatus,
  { label: string; color: string; cellFill: string; inputFill: string; inputText: string }
> = {
  // `inputFill`/`inputText` tint the row's TEXT BOX by status: Pending is a solid
  // dark grey box with BLACK text, Completed a solid dark blue box with white
  // text, and
  // Active sits between them with a light green wash.
  P: { label: 'Pending', color: '#5a6472', cellFill: 'rgba(90,100,114,0.28)', inputFill: '#5a6472', inputText: '#000000' }, // dark grey box, black text
  S: { label: 'Active', color: '#2f9e44', cellFill: 'rgba(47,158,68,0.28)', inputFill: '#e6f5ea', inputText: '#1d3b26' }, // green
  C: { label: 'Completed', color: '#2f63f0', cellFill: 'rgba(47,99,240,0.28)', inputFill: '#1e3a8a', inputText: '#ffffff' }, // dark blue
};

export const STEP_STATUS_ORDER: StepStatus[] = ['P', 'S', 'C'];

/** A step's effective status. `status` is sparse in live data (absent on rows
 *  written before the chip existed), so fall back to the `checked` flag. */
export function effectiveStatus(item: { status?: StepStatus; checked?: boolean }): StepStatus {
  return item.status ?? (item.checked ? 'C' : 'P');
}
